import { render, staticRenderFns } from "./ImportProductsFromOldStoreModal.vue?vue&type=template&id=7bbd1086&"
import script from "./ImportProductsFromOldStoreModal.vue?vue&type=script&lang=js&"
export * from "./ImportProductsFromOldStoreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports